import * as React from 'react';
import { useRef } from "react";
import Button from '@mui/joy/Button';
import FormControl from '@mui/joy/FormControl';
import FormLabel from '@mui/joy/FormLabel';
import Input from '@mui/joy/Input';
import Modal from '@mui/joy/Modal';
import ModalDialog from '@mui/joy/ModalDialog';
import DialogTitle from '@mui/joy/DialogTitle';
import DialogContent from '@mui/joy/DialogContent';
import Stack from '@mui/joy/Stack';
import axios from 'axios';
import { BASE_URL } from '../config';
import { message } from "antd";

export function LoginModal({ modalOpen, setModalOpen, setLoginStatus }) {
    const usernameRef = useRef(null);
    const passwordRef = useRef(null);
    const [messageApi, contextHolder] = message.useMessage();
    return (
        <React.Fragment>
            {contextHolder}
            <Modal open={modalOpen} onClose={() => setModalOpen(false)}>
                <ModalDialog>
                    <DialogTitle>Login Form</DialogTitle>
                    <DialogContent>Fill in the credentials.</DialogContent>
                    <form
                        onSubmit={async (event) => {
                            event.preventDefault();
                            const formData = new FormData(event.currentTarget);
                            const formJson = Object.fromEntries((formData).entries());
                            const key = 'updatable';
                            messageApi
                                .open({
                                    type: 'loading',
                                    key: key,
                                    content: 'Login in progress..',
                                    duration: 0
                                });

                            const da = { type: "login", username: formJson.username, password: formJson.password };
                            axios.post(BASE_URL + '/api/coins.php', da, { withCredentials: true }).then(response => {
                                if (response.data.status) {
                                    messageApi.open({ type: "success", content: "Login Successful", duration: 2.5, key: key });
                                    setModalOpen(false);
                                    setLoginStatus(true);
                                } else {
                                    messageApi.open({ type: "error", content: "Invalid Username or Password", duration: 3, key: key });
                                    setModalOpen(true);
                                    setLoginStatus(false);
                                }
                            }).catch(error => messageApi.open({ type: "error", content: "Login Failed", duration: 3, key: "updatable" }));

                        }}
                    >
                        <Stack spacing={2}>
                            <FormControl>
                                <FormLabel>Username</FormLabel>
                                <Input name='username' ref={usernameRef} autoFocus required />
                            </FormControl>
                            <FormControl>
                                <FormLabel>Password</FormLabel>
                                <Input name='password' ref={passwordRef} type='password' required />
                            </FormControl>
                            <Button type="submit">Login</Button>
                        </Stack>
                    </form>
                </ModalDialog>
            </Modal>
        </React.Fragment >
    );
}